// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"462":"b43efee5a033819c","819":"f0bc85a478dc42d9"}[chunkId] + ".js";
};